import React, { useContext, useEffect } from 'react'
import { MatchupContext } from '../../../../Context'
import { TeamComparison } from './TeamComparison'
import { PrevMatchupCon, PrevMatchupHead } from './styles'

export const PreviousMatchups: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { matchupInfo } = useContext(MatchupContext)!

  useEffect(() => {}, [matchupInfo?.previousMatchups])

  return (
    <>
      {matchupInfo?.previousMatchups && matchupInfo.previousMatchups.length > 0 && (
        <>
          <PrevMatchupHead>Previous Matchups</PrevMatchupHead>
          <PrevMatchupCon>
            {matchupInfo.previousMatchups.map((info) => (
              <TeamComparison key={info.eventId} matchupInfo={info} />
            ))}
          </PrevMatchupCon>
        </>
      )}
    </>
  )
}
